export enum TermFields {
	ID = "id",
	TENANT_ID = "tenantId",
	PDF_URL = "pdfUrl",
	START_DATE = "startDate",
	CANCELED = "canceled",
	TYPE = "type",
	STATUS = "status",
	FILE_NAME = "fileName"
}

export enum TermTypeFields {
	CREATED_AT = "createdAt",
	DESCRIPTION = "description",
	ID = "id",
	NAME = "name",
	UPDATED_AT = "updatedAt",
	UPDATED_BY = "updatedBy",
	STATUS = "status"
}

export type TermTypeProps = {
	[TermTypeFields.CREATED_AT]: string;
	[TermTypeFields.DESCRIPTION]: string;
	[TermTypeFields.ID]: string;
	[TermTypeFields.NAME]: string;
	[TermTypeFields.UPDATED_AT]: string;
	[TermTypeFields.UPDATED_BY]: string;
	[TermTypeFields.STATUS]: string;
};

export type TermProps = {
	[TermFields.ID]: string;
	[TermFields.TENANT_ID]: string;
	[TermFields.PDF_URL]: string;
	[TermFields.START_DATE]?: string;
	[TermFields.CANCELED]: string;
	[TermFields.TYPE]: TermTypeProps;
	[TermFields.STATUS]?: string;
	[TermFields.FILE_NAME]?: string;
};
